module.exports = __webpack_public_path__ + "static/img/no-cret.b969e95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty/no-cret.png
// module id = Cs9P
// module chunks = 152